import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { BridgeSenderHealthResponse, bridgeSenderWarningText } from '../domain/bridgeSenderHealth';
import useQuery from '../hooks/useQuery';

/** Re-read every five minutes, so the warning appears without reloading the page. */
const POLL_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Warns in the Control Room when a cash point's Delphi bridge sender looks
 * stopped. A stopped sender reports nothing itself; CASA2's kept 61 operations
 * for two days unnoticed (bridge day check 2026-10-26, G-10).
 */
const BridgeSenderAlert = () => {
    const { t } = useTranslation();
    const { data } = useQuery<BridgeSenderHealthResponse>({
        path: '/legacy-bridge-activity/senders',
        pollInterval: POLL_INTERVAL_MS,
    });

    const warnings = data?.warnings ?? [];
    if (warnings.length === 0) {
        return null;
    }

    return (
        <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            data-testid="bridge-sender-alert"
            message={t('controlRoom.bridgeSender.title')}
            description={
                <>
                    <ul style={{ margin: 0, paddingInlineStart: 20 }}>
                        {warnings.map(warning => {
                            const text = bridgeSenderWarningText(warning);
                            return <li key={warning.cashPointId}>{t(text.key, text.values)}</li>;
                        })}
                    </ul>
                    <div style={{ marginTop: 8 }}>{t('controlRoom.bridgeSender.action')}</div>
                </>
            }
        />
    );
};

export default BridgeSenderAlert;
